/* =========================================================================
   LUXURY PHASE 2 MOTION — Product page sticky add-to-cart bar
   Pure progressive enhancement: clones visible price/title text and
   triggers a real click on the theme's own submit button, so all
   variant/cart logic stays exactly as Shopify/theme intended.
   ========================================================================= */
(function () {
  'use strict';

  function initStickyAddToCart() {
    var buttonsWrap = document.querySelector('.product-form__buttons');
    var realSubmit = document.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.product__title');
    var priceEl = document.querySelector('.price__last');

    if (!buttonsWrap || !realSubmit) return; // not a product page / layout not matched

    var bar = document.createElement('div');
    bar.className = 'lux-sticky-atc';
    bar.innerHTML =
      '<div class="lux-sticky-atc__inner">' +
        '<div class="lux-sticky-atc__info">' +
          '<span class="lux-sticky-atc__title"></span>' +
          '<span class="lux-sticky-atc__price"></span>' +
        '</div>' +
        '<button type="button" class="lux-sticky-atc__btn">' + (realSubmit.textContent || 'Add to cart').trim() + '</button>' +
      '</div>';
    document.body.appendChild(bar);

    var titleSlot = bar.querySelector('.lux-sticky-atc__title');
    var priceSlot = bar.querySelector('.lux-sticky-atc__price');
    var btn = bar.querySelector('.lux-sticky-atc__btn');

    function syncContent() {
      if (titleEl && titleSlot) titleSlot.textContent = titleEl.textContent.trim();
      if (priceEl && priceSlot) priceSlot.textContent = priceEl.textContent.trim();
      btn.disabled = realSubmit.disabled;
      btn.textContent = (realSubmit.textContent || '').trim();
    }
    syncContent();

    // Keep in sync if variant changes update price/title/button state
    var mo = new MutationObserver(syncContent);
    mo.observe(realSubmit, { attributes: true, childList: true, characterData: true, subtree: true });
    if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });

    btn.addEventListener('click', function () {
      realSubmit.click();
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('lux-sticky-atc--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(buttonsWrap);
  }

  document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  document.addEventListener('shopify:section:load', initStickyAddToCart);
})();
